export default __webpack_public_path__ + "static/AccountManagement-8aa4377ba932fb3aff02913a490f407d.svg";